/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  View,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import { isWeb, isNative } from '@global/screens';
import {
  convertFullAddress,
  parseDate,
  getLongLat,
  hasNoAccess,
  convertProductPerCombinations,
  convertProductMarketType,
} from '@global/helpers';
import Colors from '@global/colors';
import { Loader, ScrollViewRefresher } from '@components/screen/Layout';
import Alert from '@components/global/Alert';
import ModalFull from '@components/modal/ModalFull';
import Button from '@components/form/Button';
import Image from '@components/global/Image';
import ItemDetail from '@components/global/ItemDetail';
import TitleSubSection from '@components/global/TitleSubSection';
import SociollaText from '@components/sociolla/SociollaText';
import StatusBadge from '@components/global/StatusBadge';
import Reschedule from '@/screens/sales-activity/components/Reschedule';
import CancelActivity from '@/screens/sales-activity/components/CancelActivity';
import SalesActivityForm from '@/screens/sales-activity/components/SalesActivityForm';
import TodoList from '@/screens/sales-activity/components/TodoList';
import MapPicker from '@components/form/MapPicker';
import Toast from 'react-native-toast-message';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import { MsAccount } from '@api/ms-account';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import { logEventScreen } from '@global/analytics';

const defaultPhoto = require('@/assets/img/default/user-default.png');
const photoSize = 35;

const dimension = Dimensions.get('window');

const tabs = [
  { name: 'Details', value: 1 },
  { name: 'To Do List', value: 2 },
];

const trash = {
  width: 13,
  height: 17,
};

const SalesActivityDetail = ({
  id,
  show,
  route = null,
  navigation = null,
  onClose,
}) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const maxHeight = dimension.height - insets.top - insets.bottom - 110;
  const hasSeeAccess = [
    'distributor_manager',
    'general_manager',
    'vice_president',
    'superadmin',
    'general',
    'regional_distributor_manager',
  ].includes(userData?.role?.code);

  const [activeTab, setActiveTab] = useState(1);
  const [showEdit, setShowEdit] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [showCancelActivity, setShowCancelActivity] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [detailCustomer, setDetailCustomer] = useState({});
  const [isSameSalesTeam, setIsSameSalesTeam] = useState(false);
  const [customerAddress, setCustomerAddress] = useState({
    address: '',
    index: -1,
  });
  const [detailTodos, setDetailTodos] = useState([]);
  const [isFetchingVisibility, setIsFetchingVisibility] = useState(false);
  //const [hasNoInvoice, setHasNoInvoice] = useState(false);

  const getActivitiesDetail = useApi(MsB2b.getActivitiesDetail);
  const getActivitiesTodos = useApi(MsB2b.getActivitiesTodos);
  const getActivityTodosDetail = useApi(MsB2b.getActivityTodosDetail);
  const getCustomerId = useApi(MsAccount.getCustomerId);
  const getOtherProducts = useApi(MsB2b.getOtherProducts);
  //const updateTodo = useApi(MsB2b.updateActivityTask);
  const routeId = route?.params?.id;
  const routeDirect = route?.params?.direct;
  const latestRequestedActivityRef = useRef(null);

  const isLatestActivity = (activityId) =>
    activityId && latestRequestedActivityRef.current === activityId;

  const getDetail = async (selectedId) => {
    const activityId = selectedId || routeId || id;
    if (!activityId) {
      return;
    }

    latestRequestedActivityRef.current = activityId;

    try {
      const response = await getActivitiesDetail.request(activityId);
      if (!isLatestActivity(activityId)) {
        return;
      }

      const activity_detail = response?.data?.data;
      if (activity_detail && Object.keys(activity_detail).length) {
        setDetailData(activity_detail);
        await getTodoList(activity_detail._id);
        if (!isLatestActivity(activity_detail._id)) {
          return;
        }

        if (activity_detail.customer) {
          if (activity_detail.activity_type == 'engage_potential_customers') {
            if (activity_detail.customer.name) {
              setDetailCustomer({ name: activity_detail.customer.name });
            }
            if (
              activity_detail?.user?.id &&
              activity_detail.user.id != userData?._id
            ) {
              getUserSalesTeam(activity_detail._id, activity_detail.user.id);
            }
          } else if (activity_detail.customer.id) {
            const customerId = activity_detail.customer.id;
            const addressId = activity_detail?.customer?.address?.id;
            const addressType =
              activity_detail?.customer?.address?.type || 'delivery';

            if (customerId && addressId && addressType) {
              await getCustomer(
                activity_detail._id,
                customerId,
                addressId,
                addressType,
                activity_detail,
              );
            }
          }
        }
      } else {
        setDetailData({});
        setDetailCustomer({});
        setDetailTodos([]);
      }
    } catch (error) {
      if (isLatestActivity(activityId)) {
        setDetailData({});
        setDetailCustomer({});
        setDetailTodos([]);
      }
    }
  };

  const getUserSalesTeam = async (activityId, smId) => {
    if (!isLatestActivity(activityId)) {
      return;
    }
    const user_salesteam = await MsAccount.getUserDetail(smId);
    if (!isLatestActivity(activityId)) {
      return;
    }

    if (user_salesteam?.data?.data?.sales_team?.length) {
      const salesteams = user_salesteam.data.data.sales_team.map((a) => a.id);
      if (
        userData?.sales_team?.findIndex((a) => salesteams.includes(a.id)) > -1
      ) {
        if (isLatestActivity(activityId)) {
          setIsSameSalesTeam(true);
        }
      }
    }
  };

  const getCustomer = async (
    activityId,
    cusId,
    addressId = '',
    addressType = 'delivery',
    activity_detail = {},
  ) => {
    if (!isLatestActivity(activityId)) {
      return;
    }
    const customer = await getCustomerId.request(cusId);
    if (!isLatestActivity(activityId)) {
      return;
    }
    if (customer?.data?.data && Object.keys(customer.data.data).length) {
      const result = customer.data.data;
      if (
        activity_detail?.activity_type != 'engage_potential_customers' &&
        userData?.sales_team?.findIndex(
          (st) => st.id == result?.sales_team?.id,
        ) > -1
      ) {
        if (isLatestActivity(activityId)) {
          setIsSameSalesTeam(true);
        }
      }
      if (isLatestActivity(activityId)) {
        setDetailCustomer(result);
      }

      if (!isLatestActivity(activityId)) {
        return;
      }

      if (activity_detail?.outlet?.id || activity_detail?.customer?.address) {
        // Sales Activity Outlet
        const outletAddress = activity_detail?.customer?.address
          ? activity_detail.customer.address
          : activity_detail?.outlet?.id
          ? {
              id: activity_detail?.outlet?.id,
              name: activity_detail?.outlet?.name,
            }
          : {
              id: '',
              name: '',
            };

        const customerAddresses =
          addressType === 'store'
            ? result?.store_address || []
            : result?.delivery_address || [];
        const addressIdx = customerAddresses?.length
          ? customerAddresses.findIndex((d) => d._id == addressId)
          : -1;

        if (isLatestActivity(activityId)) {
          setCustomerAddress({
            address: outletAddress,
            index: addressIdx > -1 ? addressIdx : 0,
          });
        }
      } else {
        const customerAddress =
          addressType === 'delivery'
            ? result?.delivery_address || []
            : result?.store_address || [];
        const addressIdx = customerAddress?.length
          ? customerAddress.findIndex((d) => d._id == addressId)
          : -1;
        if (isLatestActivity(activityId)) {
          setCustomerAddress({
            address:
              addressIdx > -1
                ? addressType === 'store'
                  ? result?.store_address[addressIdx]
                  : result?.delivery_address[addressIdx]
                : '',
            index: addressIdx,
          });
        }
      }
    } else if (isLatestActivity(activityId)) {
      setDetailCustomer({});
    }
  };

  const addressLatLong = useMemo(() => {
    if (detailData?.outlet?.id) {
      // Sales Activity Outlet
      return detailData?.customer?.address?.lat_long;
    } else {
      const activityLatLong = detailData?.customer?.address?.lat_long;
      if (activityLatLong?.latitude && activityLatLong?.longitude) {
        return activityLatLong;
      }
      return getLongLat(
        detailCustomer,
        customerAddress?.index,
        detailData?.customer?.address?.type || 'delivery',
      );
    }
  }, [detailData, customerAddress, detailCustomer]);

  const getTodoList = async (actId) => {
    if (!actId || !isLatestActivity(actId)) {
      return;
    }
    const todos = await getActivitiesTodos.request(actId);
    if (!isLatestActivity(actId)) {
      return;
    }
    if (todos?.data?.data?.length) {
      const result = todos.data.data;
      if (!isLatestActivity(actId)) {
        return;
      }
      setDetailTodos(result);
      const visibilityIndex = result.findIndex(
        (a) => a.target_type == 'visibility_update',
      );
      if (visibilityIndex > -1) {
        await getVisibilityProducts(actId, result, visibilityIndex);
      }
    } else if (isLatestActivity(actId)) {
      setDetailTodos([]);
    }
  };

  const getVisibilityProducts = async (activityId, lists, idx) => {
    if (!isLatestActivity(activityId)) {
      return;
    }
    setIsFetchingVisibility(true);
    const visibility_products = [];
    const visibility_other_products = [];
    const delay = (ms) => new Promise((r) => setTimeout(r, ms));

    try {
      let skip = 0;
      const limit = 10;
      const seenIds = new Set();

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const response = await getActivityTodosDetail.request(
          activityId,
          lists[idx]._id,
          { params: { skip, limit, sort: 'name' } },
        );

        const fetched = response?.data?.data || [];
        if (!fetched.length) {
          break;
        }
        if (!isLatestActivity(activityId)) {
          setIsFetchingVisibility(false);
          return;
        }

        const newItems = fetched.filter((pr) => {
          const fetchedId = pr?._id || pr?.id;
          if (seenIds.has(fetchedId)) {
            return false;
          }
          seenIds.add(fetchedId);
          return true;
        });

        if (newItems.length === 0) {
          break;
        }

        visibility_products.push(
          ...newItems.map((pr) => ({
            ...pr,
            id: pr?.product_id ? pr.product_id : pr.id,
            is_selected: true,
            is_saved: true,
          })),
        );

        if (fetched.length < limit) {
          break;
        }
        skip += limit;
        await delay(50);
      }
    } catch (err) {
      console.error('Error fetching visibility products:', err);
    }

    try {
      let skip = 0;
      const limit = 10;
      const seenOtherIds = new Set();

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const response = await getOtherProducts.request(activityId, {
          params: { skip, limit, sort: 'product.name' },
        });

        const fetched = response?.data?.data || [];
        if (!fetched.length) {
          break;
        }
        if (!isLatestActivity(activityId)) {
          setIsFetchingVisibility(false);
          return;
        }

        const newItems = fetched.filter((pr) => {
          const fetchedId = pr?._id || pr?.id;
          if (seenOtherIds.has(fetchedId)) {
            return false;
          }
          seenOtherIds.add(fetchedId);
          return true;
        });

        if (newItems.length === 0) {
          break;
        }

        const res_result = convertProductPerCombinations(newItems);
        const mapped = res_result.map((item) => {
          item = convertProductMarketType(item);
          item.id = item?.product_id ? item.product_id : item.id;
          item.is_selected = true;
          item.is_saved = true;

          if (item?.combination) {
            item.combination.is_other = true;
          } else if (item?.combinations?.length) {
            item.combinations = item.combinations.map((com) => ({
              ...com,
              is_other: true,
            }));
          }
          return item;
        });

        visibility_other_products.push(...mapped);

        if (fetched.length < limit) {
          break;
        }
        skip += limit;
        await delay(50);
      }
    } catch (err) {
      console.error('Error fetching other products:', err);
    }

    if (!isLatestActivity(activityId)) {
      setIsFetchingVisibility(false);
      return;
    }

    const data = JSON.parse(JSON.stringify(lists));
    data[idx].products = visibility_products;
    data[idx].other_products = visibility_other_products;

    setDetailTodos(data);
    setIsFetchingVisibility(false);

    const orderIndex = data.findIndex((a) => a.target_type === 'orders');
    if (orderIndex > -1) {
      getActivityOrder(activityId, data, orderIndex);
    }
  };

  const getActivityOrder = async (activityId, lists, idx) => {
    if (!isLatestActivity(activityId)) {
      return;
    }
    let orders = [];
    try {
      const response = await getActivityTodosDetail.request(
        activityId,
        lists[idx]._id,
        {
          params: {
            skip: 0,
            limit: 10,
          },
        },
      );
      if (!isLatestActivity(activityId)) {
        return;
      }
      if (response?.data?.data?.length) {
        orders = response.data.data;
      }
    } catch (error) {}
    if (!isLatestActivity(activityId)) {
      return;
    }
    const data = JSON.parse(JSON.stringify(lists));
    data[idx].orders = orders;
    setDetailTodos(data);
  };

  const onDelete = async (actId) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    let isSuccess = false;
    try {
      const deleteAct = await MsB2b.deleteActivity(actId);
      if (deleteAct?.data?.data) {
        isSuccess = true;
        Toast.show({ text1: 'Successfully deleted activity', type: 'success' });
      } else {
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      Toast.show({
        text1: `${error?.response?.data?.message || 'A system error occurred'}`,
        type: 'error',
      });
    } finally {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      if (isSuccess && typeof onClose === 'function') {
        onClose(true);
      }
    }
  };

  const confirmDelete = (actId) => {
    if (!actId) {
      return;
    }

    const confirmConfig = {
      title: 'Delete Activity',
      description: 'This activity will be deleted. Do you want to proceed?',
    };

    dispatch(
      showAlert({
        show: true,
        title: confirmConfig.title,
        description: confirmConfig.description,
        isConfirm: true,
        testID: 'sales-activity-detail-delete',
        onCallback: () => onDelete(actId),
      }),
    );
  };

  const isLoading = () => {
    let result = getActivitiesDetail.loading || getActivitiesTodos.loading;
    if (detailData?.customer?.id) {
      result = result || getCustomerId.loading;
    }

    if (detailData?.activity_type == 'visiting_existing_customer') {
      const isPermission = [
        'salesman',
        'beauty_advisor',
        'merchandiser',
      ].includes(userData?.role?.code);
      const loadingDetail = !isPermission ? false : isFetchingVisibility;
      const loadingTodos = loadingDetail || result;
      result = loadingTodos;
    }

    return result;
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (show) {
        if (routeDirect) {
          setActiveTab(2);
        } else {
          setActiveTab(1);
        }
        setDetailData({});
        setCustomerAddress({ address: '', index: -1 });
        setShowEdit(false);
        setShowReschedule(false);
        setShowCancelActivity(false);
        setIsSameSalesTeam(false);
        setIsFetchingVisibility(false);
        setDetailCustomer({});
        setDetailTodos([]);
        const nextActivityId = routeId || id;
        if (!nextActivityId) {
          latestRequestedActivityRef.current = null;
          return;
        }
        getDetail(nextActivityId);
      } else {
        latestRequestedActivityRef.current = null;
      }
    }
    return () => {
      mounted = false;
      latestRequestedActivityRef.current = null;
    };
  }, [show, id, routeId, routeDirect]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      let screen = 'SalesActivityDetailScreen';
      if (activeTab == 2) {
        screen = 'TodoListScreen';
      }
      logEventScreen(screen);
    }
    return () => {
      mounted = false;
    };
  }, [activeTab]);

  const isShowDelete = useMemo(() => {
    return (
      !hasNoAccess(['superadmin', 'general']) &&
      ['planned_activities', 'overdue_activities'].includes(route?.params?.type)
    );
  }, [hasNoAccess, route]);

  let mobileMenu = [];
  if (!isWeb) {
    if (
      hasNoAccess([
        'distributor_manager',
        'general_manager',
        'vice_president',
        'regional_distributor_manager',
      ]) &&
      [
        'draft',
        'approved',
        'waiting_confirmation',
        'in_progress',
        'rejected',
        'overdue',
      ].includes(detailData.status)
    ) {
      if (
        ['draft', 'waiting_confirmation', 'rejected'].includes(
          detailData.status,
        )
      ) {
        if (detailData.status != 'waiting_confirmation') {
          mobileMenu.push({
            name: 'Edit Activity',
            callback: () => setShowEdit(true),
          });
        }
        if (detailData.status == 'waiting_confirmation') {
          mobileMenu.push({
            name: 'Cancel Activity',
            callback: () => setShowCancelActivity(true),
          });
        }
      } else {
        mobileMenu = [
          { name: 'Reschedule', callback: () => setShowReschedule(true) },
          {
            name: 'Cancel Activity',
            callback: () => setShowCancelActivity(true),
          },
        ];
      }
    }
    if (isShowDelete) {
      mobileMenu.push({
        name: 'Delete',
        callback: () => confirmDelete(detailData?._id),
      });
    }
  }

  const prefix_title = detailData?._id
    ? detailData.activity_type == 'visiting_existing_customer'
      ? 'Visit'
      : detailData.activity_type == 'invoice_collection'
      ? 'Invoice Collection'
      : detailData.activity_type == 'event_activity'
      ? 'Event Activity'
      : 'Engage Potential Customer'
    : false;
  const todoActived = ['approved', 'in_progress', 'finished'].includes(
    detailData.status,
  );

  const RemoveIcon = useMemo(() => {
    return isShowDelete ? (
      <Button
        testID="sales-activity-detail-delete-btn"
        type="danger"
        rounded
        buttonStyle={{ width: 42 }}
        title={
          <Image
            style={{
              width: trash.width,
              height: trash.height,
            }}
            width={trash.width}
            height={trash.height}
            source={require('@assets/img/icons/trash-white.svg')}
            svg
          />
        }
        onPress={() => confirmDelete(detailData._id)}
      />
    ) : (
      false
    );
  }, [isShowDelete, confirmDelete, detailData, trash]);

  const _getModalFullProps = () => ({
    testID: 'sales-activity-detail-modal',
    title: prefix_title
      ? `${prefix_title}${
          detailCustomer.name ? ` - ${detailCustomer.name}` : '-'
        }`
      : 'Loading...',
    show: show,
    back: !isWeb,
    width: 650,
    onClose: () => {
      onClose();
    },
    withMobileMenu: true,
    mobileMenu: mobileMenu,
  });

  const renderLoadingComponent = () => <Loader />;

  const renderNoDataFound = () => (
    <View
      testID="sales-activity-detail-no-data"
      style={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}>
      <SociollaText>No data found</SociollaText>
    </View>
  );

  const renderCustomerImage = () => (
    <View
      style={{
        borderRadius: photoSize,
        backgroundColor: Colors.grey0,
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        width: photoSize,
        height: photoSize,
        marginRight: 15,
      }}>
      <Image
        source={
          Array.isArray(detailCustomer?.image) &&
          detailCustomer?.image.length > 0
            ? detailCustomer?.image[0]
            : detailCustomer?.image !== ''
            ? detailCustomer?.image
            : defaultPhoto
        }
        isPhoto={true}
        style={{ width: photoSize, height: photoSize }}
        width={photoSize}
        height={photoSize}
        defaultSource={defaultPhoto}
      />
    </View>
  );

  const renderCustomerName = () => (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb
          ? {
              maxWidth:
                detailData.activity_type != 'engage_potential_customers'
                  ? '100%'
                  : `calc(100% - 50px)`,
            }
          : {}),
      }}>
      <SociollaText type="medium" style={{ fontSize: 16 }}>
        {detailCustomer.name ? detailCustomer.name : '-'}
      </SociollaText>
    </View>
  );

  const renderLeftTopContent = () => (
    <View style={[styles.innerRow, isWeb && styles.innerRowWeb]}>
      {detailData.activity_type != 'engage_potential_customers' &&
        renderCustomerImage()}
      {renderCustomerName()}
    </View>
  );

  const renderEditButton = () => (
    <Button
      testID="sales-activity-detail-edit-btn"
      rounded={true}
      type="primary"
      buttonStyle={{
        width: 120,
        ...(isShowDelete ? { marginLeft: 10 } : {}),
      }}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.white }}>
          Edit Activity
        </SociollaText>
      }
      onPress={() => setShowEdit(true)}
    />
  );

  const renderCancelActivity = () => (
    <Button
      testID="sales-activity-detail-cancel-btn"
      rounded={true}
      type="primary"
      buttonStyle={{ width: 130, marginLeft: 10 }}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.white }}>
          Cancel Activity
        </SociollaText>
      }
      onPress={() => setShowCancelActivity(true)}
    />
  );

  const renderButtonGrantAccess = () => (
    <View
      style={
        detailData.status == 'waiting_confirmation' || isShowDelete
          ? { flexDirection: 'row' }
          : {}
      }>
      {/* {ExportOverdue} */}
      {RemoveIcon}
      {detailData.status != 'waiting_confirmation' && renderEditButton()}
      {detailData.status == 'waiting_confirmation' && renderCancelActivity()}
    </View>
  );

  const renderButtonNonGrantAccess = () => (
    <View style={{ flexDirection: 'row' }}>
      {/* {ExportOverdue} */}
      {RemoveIcon}
      <Button
        testID="sales-activity-detail-reschedule-btn"
        rounded={true}
        buttonStyle={{
          width: 110,
          marginRight: 10,
          ...(isShowDelete ? { marginLeft: 10 } : {}),
        }}
        title={
          <SociollaText
            type="medium"
            style={{ fontSize: 14, color: Colors.white }}>
            Reschedule
          </SociollaText>
        }
        onPress={() => setShowReschedule(true)}
      />
      <Button
        testID="sales-activity-detail-cancel-activity-btn"
        rounded={true}
        type="primary"
        buttonStyle={{ width: 130 }}
        title={
          <SociollaText
            type="medium"
            style={{ fontSize: 14, color: Colors.white }}>
            Cancel Activity
          </SociollaText>
        }
        onPress={() => setShowCancelActivity(true)}
      />
    </View>
  );

  const rightHeaderAccessContent = () => {
    const isGetAccess = ['draft', 'waiting_confirmation', 'rejected'].includes(
      detailData.status,
    );

    return (
      <React.Fragment>
        {isGetAccess ? renderButtonGrantAccess() : renderButtonNonGrantAccess()}
      </React.Fragment>
    );
  };

  const renderRightHeaderContent = () => {
    const listRoleGetAccess = [
      'distributor_manager',
      'general_manager',
      'vice_president',
      'regional_distributor_manager',
    ];
    const listStepGetAccess = [
      'draft',
      'approved',
      'waiting_confirmation',
      'in_progress',
      'rejected',
      'overdue',
    ];

    const isNoAccess =
      hasNoAccess(listRoleGetAccess) &&
      listStepGetAccess.includes(detailData.status);

    return (
      <React.Fragment>
        {isNoAccess && rightHeaderAccessContent()}
      </React.Fragment>
    );
  };

  const renderTopContent = () => (
    <View
      testID="sales-activity-detail-header"
      style={styles.scrollViewContainer}>
      {renderLeftTopContent()}
      {isWeb && renderRightHeaderContent()}
    </View>
  );

  const renderTabPointing = (item, idx) => (
    <TouchableOpacity
      testID={`sales-activity-detail-tab-${item.name
        .toLowerCase()
        .replace(/\s+/g, '-')}`}
      onPress={() => {
        if (item.value == 2 ? todoActived : true) {
          setActiveTab(item.value);
        }
      }}
      activeOpacity={0.6}
      style={{
        minWidth: isWeb ? 150 : '50%',
        padding: 15,
        borderBottomWidth: 2,
        borderBottomColor:
          activeTab == item.value ? Colors.blue0 : 'transparent',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      key={idx}>
      <SociollaText
        type={activeTab == item.value ? 'medium' : 'regular'}
        style={{
          color:
            activeTab == item.value
              ? Colors.blue0
              : (item.value == 2 ? todoActived : true)
              ? Colors.black
              : Colors.grey0,
        }}>
        {item.name}
      </SociollaText>
    </TouchableOpacity>
  );

  const renderTabs = () => (
    <View style={styles.tabContent}>
      {tabs.map((item, idx) => renderTabPointing(item, idx))}
    </View>
  );

  const renderCustomerInfo = () => (
    <ScrollView testID="sales-activity-detail-customer-info">
      <TitleSubSection title="CUSTOMER INFO" />
      <View
        style={[
          styles.listSection,
          { flexDirection: isWeb ? 'row' : 'column', width: '100%' },
        ]}>
        <View style={{ flex: 1, marginRight: isWeb ? 20 : 0 }}>
          <ItemDetail
            name="Alias / Name"
            value={detailCustomer.name ? detailCustomer.name : '-'}
          />
          <ItemDetail
            name="Address"
            value={convertFullAddress(
              detailData?.outlet?.id
                ? detailData?.customer?.address
                : customerAddress?.address,
            )}
          />
          <ItemDetail
            name={`${
              detailData?.customer?.address?.type === 'store'
                ? 'Store'
                : 'Delivery'
            } Name`}
            value={customerAddress?.address?.name || '-'}
          />
          {detailData.activity_type !== 'engage_potential_customers' && (
            <ItemDetail
              name="Outlet Name"
              value={detailData?.outlet?.name || '-'}
            />
          )}
          <ItemDetail name="Phone" value={detailCustomer.phone} />
          <ItemDetail name="Mobile" value={detailCustomer.mobile} />
        </View>
        <View style={{ flex: 1 }}>
          {addressLatLong ||
          (detailData?.outlet?.id &&
            detailData?.customer?.address?.lat_long) ? (
            <ItemDetail
              name="Location"
              style={{ flexDirection: 'column' }}
              valueComponent={
                <MapPicker
                  value={addressLatLong}
                  hideInput={true}
                  disabled={true}
                  editable={false}
                  containerStyle={{
                    marginTop: 14,
                    borderRadius: 4,
                    width: '100%',
                  }}
                />
              }
            />
          ) : (
            false
          )}
        </View>
      </View>
      <TitleSubSection title="ACTIVITY DETAIL" />
      <View style={styles.listSection}>
        <ItemDetail
          name="Sales Person"
          centered
          value={`${detailData?.user?.name ? detailData?.user?.name : '-'}`}
        />
        <ItemDetail
          name="Visit Date"
          value={`${
            detailData.visited_at
              ? parseDate(detailData.visited_at, 'dd MMM yyyy')
              : '-'
          } ${
            detailData?.start_time && detailData?.end_time
              ? `${detailData?.start_time} - ${detailData?.end_time}`
              : `-`
          }`}
        />
        <ItemDetail
          name="Status"
          centered
          value={<StatusBadge status={detailData.status} />}
        />
        {detailData.status == 'finished' ? (
          <ItemDetail
            name="Completed Date"
            value={
              detailData.finished_at
                ? parseDate(detailData.finished_at, 'dd MMM yyyy HH:mm')
                : '-'
            }
          />
        ) : (
          false
        )}
        {detailData.activity_type === 'event_activity' && (
          <ItemDetail name="Event Name" value={detailData.event_name || '-'} />
        )}
        <ItemDetail name="Notes" value={detailData.notes} />
      </View>
      <View style={{ height: 200 }}></View>
    </ScrollView>
  );

  const renderWordingWrongPlatform = () => (
    <View style={styles.todoStyle}>
      <SociollaText>Please use B2B app to access this page</SociollaText>
    </View>
  );

  const renderTodoList = () => {
    return (
      <View
        testID="sales-activity-detail-todo-list"
        style={{ width: '100%', minHeight: 200 }}>
        <TodoList
          route={route}
          navigation={navigation}
          detailData={detailData}
          detailTodos={detailTodos}
          detailCustomer={detailCustomer}
          //hasNoInvoice={hasNoInvoice}
          onSubmit={() => getDetail(detailData?._id || routeId || id)}
          onCloseDetail={() => onClose()}
          customerAddress={customerAddress}
        />
      </View>
    );
  };

  const noHavePermissionComponent = () => (
    <View style={styles.todoStyle}>
      <SociollaText>You don't have permission to access this page</SociollaText>
    </View>
  );

  const renderTodoComponent = () => {
    const isNotCorrectPlatform =
      !isNative && ['approved', 'in_progress'].includes(detailData.status);
    const correctStatusActive = [
      'approved',
      'in_progress',
      'finished',
    ].includes(detailData.status);
    const correctValidation =
      detailData?.user?.id == userData._id || isSameSalesTeam || hasSeeAccess;
    const isAccessAble =
      !isNotCorrectPlatform && correctStatusActive && correctValidation;
    const shouldRenderNoPermission =
      !isNotCorrectPlatform && (!correctValidation || !correctStatusActive);

    return (
      <React.Fragment>
        {isNotCorrectPlatform && renderWordingWrongPlatform()}
        {isAccessAble && renderTodoList()}
        {shouldRenderNoPermission && noHavePermissionComponent()}
      </React.Fragment>
    );
  };

  const renderTabContent = () => (
    <React.Fragment>
      {activeTab == 1 && renderCustomerInfo()}
      {activeTab == 2 && renderTodoComponent()}
    </React.Fragment>
  );

  const renderSalesActivityDetail = () => (
    <ScrollViewRefresher
      maxHeight={isWeb ? maxHeight : 0}
      style={{
        flex: 1,
      }}
      onCallback={() => getDetail(detailData?._id || routeId || id)}>
      {renderTopContent()}
      {renderTabs()}
      {renderTabContent()}
    </ScrollViewRefresher>
  );

  const renderAllContent = () => {
    const isHaveData = detailData && Object.keys(detailData).length;

    return isHaveData ? renderSalesActivityDetail() : renderNoDataFound();
  };

  const renderRescheduleModal = () => (
    <Reschedule
      detailData={detailData}
      show={showReschedule}
      onSubmit={() => {
        setShowReschedule(false);
        getDetail(detailData?._id || routeId || id);
      }}
      onClose={() => setShowReschedule(false)}
    />
  );

  const renderCancelActivityModal = () => (
    <CancelActivity
      id={detailData._id}
      show={showCancelActivity}
      onSubmit={() => {
        setShowCancelActivity(false);
        getDetail(detailData?._id || routeId || id);
        Toast.show({
          text1: 'Activity plan has been cancelled',
          type: 'success',
        });
      }}
      onClose={() => setShowCancelActivity(false)}
    />
  );

  const renderSalesActivityFormModal = () => (
    <SalesActivityForm
      show={showEdit}
      detailData={detailData}
      activityType={detailData.activity_type}
      onSubmit={async () => {
        setShowEdit(false);
        onClose(true);
      }}
      onClose={() => setShowEdit(false)}
    />
  );

  const renderActivityModals = () => (
    <React.Fragment>
      {renderRescheduleModal()}
      {renderCancelActivityModal()}
      {renderSalesActivityFormModal()}
      <Alert />
    </React.Fragment>
  );

  return (
    <ModalFull {..._getModalFullProps()}>
      {isLoading() && renderLoadingComponent()}
      {!isLoading() && renderAllContent()}
      {renderActivityModals()}
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  listSection: {
    paddingTop: 10,
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  todoStyle: {
    width: '100%',
    minHeight: 200,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  scrollViewContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 20,
  },
  innerRow: {
    flexDirection: 'row',
  },
  innerRowWeb: {
    maxWidth: 'calc(100% - 260px)',
  },
  tabContent: {
    flexDirection: 'row',
    borderTopColor: isWeb ? 'transparent' : Colors.grey0,
    borderTopWidth: 1,
  },
});

export default React.memo(SalesActivityDetail, (prev, next) => prev == next);
